import { Component, Input, Output,EventEmitter, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgePipe } from "../shared/pipes/age.pipe";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { StatusLablesComponent } from "../shared/components/status-lables/status-lables.component";
import { EntityType } from '../shared/share';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-app-admin-table-view',
  standalone: true,
  imports: [CommonModule, AgePipe, StatusLablesComponent,MatTooltipModule],
  templateUrl: './app-admin-table-view.component.html',
  styleUrl: './app-admin-table-view.component.scss'
})
export class AppAdminTableViewComponent {

  @Input() data:any;
  @Input() columnDisplayNames:any;
  @Input () TableFor:string=''
  @Output() openInsurerAdmin = new EventEmitter<any>();
@Output() openProviderAdmin =new EventEmitter<any>();
@Output() updateStatus = new EventEmitter<{ item: any, isActive: boolean }>();
@Output()openAdminInsurerForm =new EventEmitter<any>();
@Output()openAdminDistributerProfile =new EventEmitter<any>();
@Output() openAdminProile=new EventEmitter<any>();
@Output() confirmStatusUpdateTrue=new EventEmitter<any>();
@Output() confirmStatusUpdateFalse=new EventEmitter<any>();
  enumEntityType = EntityType;

    constructor(private matdialog: MatDialog) { }
  
  ngOnInIt(){
    console.log(this.data,this.columnDisplayNames)
  }

  
    confirmStatusUpdate(item: any, isActive: boolean, event?: MouseEvent) {
      if (event) { event.stopPropagation(); }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
  
      const dialogRef = this.matdialog.open(ConfirmationmodalComponent, dialogConfig);
      dialogRef.componentInstance.title = 'Confirm';
      dialogRef.componentInstance.mode = 'Add';
      dialogRef.componentInstance.message = 'Are you sure you want to update the status?';
  
      dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {
          this.updateStatus.emit({ item, isActive });
        }
      });
    }

}
